import { Navigate, Outlet, Route, RouteProps, Routes } from 'react-router-dom'
import LoginPage from '../pages/login/LoginPage'
import HomePage from '../pages/home/HomePage'
import AboutPage from '../pages/about/AboutPage'
import { useAppSelector } from '../redux/hooks'
import { selectAuthenticatedUser } from '../redux/slices/auth.slice'
import DatabasePage from '../pages/database/databasePage'
import ArtsPage from '../pages/arts/ArtsPage'
import AddArtPage from '../pages/arts/AddArtPage'
import ArtPage from '../pages/arts/ArtPage'
import AdminLayout from '../pages/admin/AdminLayout'
import AdminDashboard from '../pages/admin/AdminDashboard'
import UserManagement from '../pages/admin/UserManagement'
import SettingsManagement from '../pages/admin/SettingsManagement'
import PromptsManagement from '../pages/admin/PromptsManagement'
import SandboxPage from '../pages/admin/SandboxPage'
import AdminGuard from '../components/AdminGuard'
import AccountSettingsPage from '../pages/account/AccountSettingsPage'

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({ ...rest }: RouteProps): React.ReactElement | null => {
  const { access_token } = useAppSelector(selectAuthenticatedUser)
  // return access_token ? <Route {...rest} /> : <Route {...rest} element={<Navigate replace to="/" />} />
  return access_token ? <Outlet /> : <Navigate to="/" />
}

const RootNavigation = () => {
  return (
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/database" element={<DatabasePage />} />
        <Route path="/arts/:type" element={<ArtsPage />} />
        <Route path="/arts/add/:type" element={<AddArtPage />} />
        <Route path="/arts/view/:id" element={(<ArtPage />)} />
        <Route path="/my" element={<PrivateRoute />}>
        </Route>
        <Route path="/profile" element={<PrivateRoute />}>
          <Route index element={<AccountSettingsPage />} />
        </Route>
        <Route path="/about" element={<AboutPage />} />
        
        {/* Admin Routes - Protected by AdminGuard */}
        <Route path="/admin" element={<AdminGuard />}>
          <Route element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="settings" element={<SettingsManagement />} />
            <Route path="prompts" element={<PromptsManagement />} />
            <Route path="sandbox" element={<SandboxPage />} />
          </Route>
        </Route>
      </Routes>
  )
}

export default RootNavigation
